import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AuthService from "../../services/auth.service";

// **Async Thunks**
export const authLogin = createAsyncThunk(
  "auth/authLogin",
  async (item, thunkAPI) => {
    try {
      const data = await AuthService.login(item);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data);
    }
  }
);

export const createhoteladmin = createAsyncThunk(
  "auth/createhoteladmin",
  async (item, thunkAPI) => {
    try {
      const data = await AuthService.addhoteladmin(item);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const getHotelAdmins = createAsyncThunk(
  "auth/getHotelAdmins",
  async (item, thunkApi) => {
    try {
      const response = await AuthService.getHotelAdmin(item);
      return response.data;
    } catch (error) {
      return thunkApi.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const edithoteladmin = createAsyncThunk(
  "auth/edithoteladmin",
  async (item, thunkAPI) => {
    try {
      const data = await AuthService.editHotelAdmin(item);
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || error.message
      );
    }
  }
);

export const logout = createAsyncThunk("auth/logout", async () => {
  AuthService.removeUserDetails();
});

// **Initial State**
const initialState = {
  loading: false,
  error: "",
  hotelAdmins: [], // ✅ Ensure it's an array from the beginning
  user: AuthService.getUserDetails() || null,
};

// **Slice**
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // **Handle Login**
      .addCase(authLogin.pending, (state) => {
        state.loading = true;
        state.error = "";
        state.user = null;
      })
      .addCase(authLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
      })
      .addCase(authLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Logout**
      .addCase(logout.fulfilled, (state) => {
        state.loading = false;
        state.error = "";
        state.user = null;
      })

      // **Handle Create Hotel Admin**
      .addCase(createhoteladmin.pending, (state) => {
        state.loading = true;
      })
      .addCase(createhoteladmin.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createhoteladmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Get Hotel Admins**
      .addCase(getHotelAdmins.pending, (state) => {
        state.loading = true;
      })
      .addCase(getHotelAdmins.fulfilled, (state, action) => {
        state.loading = false;
        state.hotelAdmins = action.payload || []; // ✅ Ensure it's always an array
      })
      .addCase(getHotelAdmins.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // **Handle Edit Hotel Admin**
      .addCase(edithoteladmin.pending, (state) => {
        state.loading = true;
      })
      .addCase(edithoteladmin.fulfilled, (state, action) => {
        state.loading = false;

        // ✅ Ensure `hotelAdmins` is always an array
        if (!Array.isArray(state.hotelAdmins)) {
          state.hotelAdmins = [];
        }

        const index = state.hotelAdmins.findIndex(
          (admin) => admin.id === action.payload.id
        );

        if (index !== -1) {
          // ✅ Update existing hotel admin
          state.hotelAdmins[index] = action.payload;
        } else {
          // ✅ If the hotel admin is not in the array, add it
          state.hotelAdmins.push(action.payload);
        }
      })
      .addCase(edithoteladmin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

// **Export Reducer**
export default authSlice.reducer;
